/* eslint-disable */
import * as React from 'react';
const SvgGrayEnvelopeIcon = (props) => (React.createElement("svg", { viewBox: "0 0 326.5 221", width: "1em", height: "1em", ...props },
    React.createElement("path", { d: "M159.7 123.2L14.4 0h298L167.1 123.2c-2.1 1.8-5.3 1.8-7.4 0zM26.8 184L0 206.7V14.3l113.5 96.2z" }),
    React.createElement("path", { d: "M274.3 188l38.9 33H14.5l43.6-37 71-60.2 18.7 15.8 11.9 10.1c2.1 1.8 5.3 1.8 7.4 0l11.9-10.1 19.1-16.2zM326.5 14.6v191.2L305.6 188l-91.8-77.8z" })));
export default SvgGrayEnvelopeIcon;
/* eslint-enable */
